/* Velvt browser session: three hours without a user gesture, including suspended tabs. */
(function () {
  'use strict';
  if (window.RVS_SESSION) return;
  var script = document.currentScript, cid = script && script.dataset.customerId, direct;
  try { direct=JSON.parse(sessionStorage.getItem('velvt:direct-session')||'null'); if(direct&&direct.user_id)cid='velvt:'+direct.user_id; } catch (_) {}
  var CURRENT = 'velvt:session:current', PREFIX = 'velvt:session:v1:', LIMIT = 3 * 60 * 60 * 1000;
  function read(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) { return null; } }
  function write(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {} }
  if (!cid) {
    var old = read(CURRENT);
    if (old) { try { localStorage.removeItem(PREFIX + old); localStorage.removeItem(CURRENT); } catch (_) {} }
    return;
  }
  var key = PREFIX + cid, record = read(key), now = Date.now(), expired = false, timer, clients = [];
  var generation = record && record.generation || Math.random().toString(36).slice(2) + now;
  var lastActive = record && Number(record.lastActive) || now;
  if (lastActive > now + 60000) lastActive = now;
  function logoutURL() {
    if(direct)return 'https://velvt.io/?mode=signin#join';
    try { var u = new URL(script.dataset.logout || '/account/logout', location.origin); if (u.origin === location.origin) return u.href; } catch (_) {}
    return '/account/logout';
  }
  function cover() {
    var box = document.createElement('div'); box.dataset.velvtSessionEnded = '';
    box.setAttribute('role', 'alert');
    box.style.cssText = 'position:fixed;inset:0;z-index:2147483647;background:#f7f5fa;color:#21172c;display:grid;place-content:center;gap:16px;padding:24px;text-align:center;font:16px/1.5 system-ui';
    var h = document.createElement('h1'); h.textContent = 'Your Velvt session has ended';
    var p = document.createElement('p'); p.textContent = 'You were inactive for three hours. Signing you out…';
    var a = document.createElement('a'); a.textContent = 'Continue to sign out'; a.href = logoutURL();
    box.append(h, p, a); document.body.appendChild(box);
    document.querySelectorAll('dialog[open]').forEach(function(dialog){dialog.close();});
    document.querySelectorAll('[data-rvs-hub]').forEach(function(root){root.hidden=true;root.inert=true;});
    document.querySelectorAll('video,audio').forEach(function (media) { media.pause(); media.muted = true; });
  }
  function expire(broadcast) {
    if (expired) return false;
    expired = true; clearTimeout(timer);
    try { sessionStorage.removeItem('velvt:direct-session'); } catch (_) {}
    if (broadcast) write(key, { lastActive: lastActive, generation: generation, expired: true });
    try { sessionStorage.removeItem('velvt:invite-signout'); } catch (_) {}
    cover();
    document.dispatchEvent(new CustomEvent('rvs-session-expired'));
    clients.forEach(function (client) {
      try { client.auth.stopAutoRefresh(); client.removeAllChannels(); } catch (_) {}
      // Revoke only this browser session. Never sign out the member's other devices.
      try { Promise.resolve(client.auth.signOut({ scope: 'local' })).catch(function () {}); } catch (_) {}
    });
    location.replace(logoutURL());
    return false;
  }
  function check() {
    if (expired) return false;
    var shared = read(key);
    if (shared && shared.generation !== generation) {
      // A different login replaced this page. Reload before using its old in-memory credentials.
      expired = true; clearTimeout(timer); location.reload(); return false;
    }
    if (shared && shared.expired) return expire(false);
    if (shared) lastActive = Math.max(lastActive, Number(shared.lastActive) || 0);
    if (Date.now() - lastActive >= LIMIT) return expire(true);
    return true;
  }
  function schedule() { clearTimeout(timer); if (!expired) timer = setTimeout(function () { if (check()) schedule(); }, Math.max(1, LIMIT - (Date.now() - lastActive))); }
  function activity(event) {
    if (!event.isTrusted || document.hidden || !check()) return;
    var t = Date.now();
    if (t - lastActive < 1000) return;
    lastActive = t; write(key, { lastActive: t, generation: generation }); schedule();
  }
  window.RVS_SESSION = {
    check: check,
    register: function (client) { clients.push(client); if (!check()) { try { client.auth.stopAutoRefresh(); client.removeAllChannels(); } catch (_) {} } },
    // Explicit sign-out also ends other open tabs immediately.
    end: function () { expire(true); }
  };
  write(CURRENT, cid);
  if (!record) write(key, { lastActive: lastActive, generation: generation });
  if (!check()) return;
  ['pointerdown', 'keydown', 'touchstart', 'wheel', 'input'].forEach(function (name) { document.addEventListener(name, activity, { passive: true, capture: true }); });
  function resume() { if (check()) schedule(); }
  window.addEventListener('pageshow', resume); window.addEventListener('focus', resume);
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('storage', function (event) {
    if (event.key !== key) return;
    if (event.newValue === null) { expire(false); return; }
    resume();
  });
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (link && !event.defaultPrevented && (/\/account\/logout/.test(link.href) || link.href === new URL(logoutURL(), location.origin).href)) {
      if(direct){event.preventDefault();expire(true);return;}
      write(key, { lastActive: lastActive, generation: generation, expired: true });
    }
  });
  schedule();
})();

